"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateItineraryOnlyPrice = exports.formatPerPerson = exports.calculateTotalPriceTiers = exports.calculateTieredTotalPrice = exports.fillPricePerPerson = exports.getPricePerPerson = void 0;
var Reservation_1 = require("./Reservation");
var getPricePerPerson = function (tripPrice) {
    // returns multiples(in number of persons) of tripPrice
    return [tripPrice, (tripPrice * 2), (tripPrice * 3), (tripPrice * 4), (tripPrice * 5), (tripPrice * 6)];
};
exports.getPricePerPerson = getPricePerPerson;
var fillPricePerPerson = function (tripPrice, inventoryPricePerPerson, tripPricePerPerson) {
    // if inventoryPricePerPerson is not valid, use tripPricePerPerson else use inventoryPricePerPerson
    var pricePerPerson = !inventoryPricePerPerson || inventoryPricePerPerson.every(function (p) { return !p; }) ? tripPricePerPerson : inventoryPricePerPerson;
    var result = [tripPrice, tripPrice, tripPrice, tripPrice, tripPrice, tripPrice];
    if (!pricePerPerson) {
        return result;
    }
    var price = tripPrice;
    for (var i = 0; i < 6; i += 1) {
        price = pricePerPerson[i] || price;
        result[i] = price;
    }
    return result;
};
exports.fillPricePerPerson = fillPricePerPerson;
var calculateTieredTotalPrice = function (people, tripPrice, inventoryPricePerPerson, tripPricePerPerson) {
    var tiers = (0, exports.fillPricePerPerson)(tripPrice, inventoryPricePerPerson, tripPricePerPerson);
    if (people <= 6) {
        return tiers[people - 1];
    }
    return tiers[5];
};
exports.calculateTieredTotalPrice = calculateTieredTotalPrice;
var calculateTotalPriceTiers = function (tripPrice, inventoryPricePerPerson, tripPricePerPerson) {
    return (0, exports.fillPricePerPerson)(tripPrice, inventoryPricePerPerson, tripPricePerPerson);
};
exports.calculateTotalPriceTiers = calculateTotalPriceTiers;
var formatPerPerson = function (person) { return (person < 5 ? (person + 1).toString(10) : '6+'); };
exports.formatPerPerson = formatPerPerson;
var calculateItineraryOnlyPrice = function (tripItineraryOnlyPrice) {
    return tripItineraryOnlyPrice || Reservation_1.ITINERARY_ONLY_PRICE;
};
exports.calculateItineraryOnlyPrice = calculateItineraryOnlyPrice;
//# sourceMappingURL=Inventory.js.map